<template>
    <div>
        <form method="post" @submit.prevent="buscar">
            <div class="input-group busqueda">
                <input type="text" class="form-control" placeholder="Buscar" aria-label="Buscar" aria-describedby="buscar" v-model="busqueda">
                <button class="btn btn-outline-secondary" type="submit" id="buscar">
                    <i class="fas fa-search"></i>
                </button>
            </div>
        </form>
    </div>
</template>

<script>

export default {
    data() {
        return {
            busqueda: null,
        };
    },
    methods: {
        buscar() {
            window.location.href ='/buscar?q='+this.busqueda;
        }
    },
    mounted: function () {

    }
};
</script>
